const SCROLL_ANIMATION_TRIGGER_CLASSNAME = ".animation-trigger";

const animatedSections = Array.from(
	document.querySelectorAll(".shopify-section")
).filter((section) =>
	section.querySelector(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
);

const onIntersection = (elements, observer) => {
	elements.forEach((element) => {
		if (element.isIntersecting) {
			const target = element.target;
			const parentSection =
				target.closest(".slideshow .hero") ||
				target.closest(".shopify-section");
			if (parentSection) {
				const triggers = Array.from(
					parentSection.querySelectorAll(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
				);
				const index = triggers.indexOf(target);
				target.style.transitionDelay = `${index * 0.1}s`;
			}
			target.classList.add("visible");
			observer.unobserve(target);
		}
	});
};

const initAnimations = (rootEl = document) => {
	const elements = rootEl.querySelectorAll(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
	if (elements.length === 0) return;

	const observer = new IntersectionObserver(onIntersection, {
		rootMargin: "0px 0px -50px 0px",
	});
	elements.forEach((element) => observer.observe(element));
};

window.addEventListener("DOMContentLoaded", () => {
	initAnimations();
});

if (Shopify.designMode) {
	document.addEventListener("shopify:section:load", (event) =>
		initAnimations(event.target, true)
	);
}
